import { render, staticRenderFns } from "./RegionCreate.vue?vue&type=template&id=e5d2078a"
import script from "./RegionCreate.vue?vue&type=script&lang=js"
export * from "./RegionCreate.vue?vue&type=script&lang=js"
import style0 from "./RegionCreate.vue?vue&type=style&index=0&id=e5d2078a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports